import type { FC } from 'react';

import { Timecode } from '../../../../components/fields/timecode/timecode';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = ['timecodeOptions', 'renderer'] as const;

const Field = formField(Timecode, {
  transformProps: (props) => pickProps(props, componentProps),
});

export type TimecodeFieldWrapperProps = FieldWrapperProps<typeof Field>;

const TimecodeFieldWrapper: FC<TimecodeFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default TimecodeFieldWrapper;
